import script from "./SegmentedControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentedControl.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentedControl.vue?vue&type=style&index=0&id=c0494a60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0494a60"]])

export default __exports__